import React from "react";
import styles from "./style.module.scss";
import { useTranslation } from "next-i18next";
import { convertLangToKZISO } from "../../services/utiltyService";
import { trackEvent } from "@kunduz/utility-analytics";
import { getQIUrl } from "@kunduz/utility-common";
import { useQISUGLinkedQuestion } from "@kunduz/feature-question-indexing";

const SugPrevNextButtons = (props: Props) => {
  const LinkComponent = props.linkAs ?? "a";
  const { t } = useTranslation("questionIndexing");

  const { linkedQuestion: prevQuestion } = useQISUGLinkedQuestion(
    props.subjectId,
    props.questionId,
    true,
    convertLangToKZISO(props.lang)
  );

  const { linkedQuestion: nextQuestion } = useQISUGLinkedQuestion(
    props.subjectId,
    props.questionId,
    false,
    convertLangToKZISO(props.lang)
  );

  function printPrev(question) {
    function onPrevClicked(e) {
      trackEvent("Question Indexing Previous Question Button Clicked", {
        course: question?.course,
        subject: question?.subject,
        page_slug: question?.slug,
      });
    }
    if (question) {
      return (
        <LinkComponent
          className="btn"
          onClick={onPrevClicked}
          href={getQIUrl({
            lang: props.lang,
            questionSlug: question.slug,
            questionId: question.id,
          })}
        >
          {"<"} {t("question_indexing_question_previous_button")}
        </LinkComponent>
      );
    }
    return null;
  }
  function printNext(question) {
    function onNextClicked(e) {
      trackEvent("Question Indexing Next Question Button Clicked", {
        course: question?.course,
        subject: question?.subject,
        page_slug: question?.slug,
      });
    }
    if (question) {
      return (
        <LinkComponent
          className="btn"
          onClick={onNextClicked}
          href={getQIUrl({
            lang: props.lang,
            questionSlug: question.slug,
            questionId: question.id,
          })}
        >
          {t("question_indexing_question_next_button")} {">"}
        </LinkComponent>
      );
    }
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {prevQuestion && printPrev(prevQuestion)}
      {nextQuestion && printNext(nextQuestion)}
    </div>
  );
};

interface Props {
  subjectId: number;
  questionId: number;
  lang: "tr" | "en";
  linkAs?: React.ElementType;
}

export default SugPrevNextButtons;
